import { useLayoutEffect, useRef } from "react";

/**
 * For the fixed marketing headers (seasonal strip + nav). The strip wraps to
 * a different height per viewport — or is hidden out of season — so the
 * header publishes its live height as `--site-header-h` on <html> for the
 * content below to offset by (hero padding, form scroll margin).
 *
 * (`position: sticky` would avoid this, but html/body/#root set
 * `overflow-x: hidden`, which breaks sticky.)
 */
export function useSiteHeaderHeight<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);

  useLayoutEffect(() => {
    const header = ref.current;
    if (!header) return;
    const root = document.documentElement;
    const publish = () =>
      root.style.setProperty("--site-header-h", `${header.offsetHeight}px`);
    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(header);
    return () => {
      observer.disconnect();
      root.style.removeProperty("--site-header-h");
    };
  }, []);

  return ref;
}
